import { theme } from '../styles/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'relative',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    minHeight: '44px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    border: `1px solid ${theme.colors.border.light}`,
    borderRadius: theme.borderRadius.lg,
    cursor: 'pointer',
    fontSize: theme.fontSize.sm,
    fontWeight: '600',
    fontFamily: 'inherit',
    transition: 'all 0.2s',
  },
  flag: {
    fontSize: '18px',
  },
  code: {
    fontSize: theme.fontSize.sm,
  },
  arrow: {
    fontSize: '10px',
    marginLeft: '2px',
    color: theme.colors.text.secondary,
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '4px',
    backgroundColor: theme.colors.background.primary,
    border: `1px solid ${theme.colors.border.light}`,
    borderRadius: theme.borderRadius.lg,
    minWidth: '160px',
    zIndex: 1000,
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    width: '100%',
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    minHeight: '44px',
    backgroundColor: 'transparent',
    color: theme.colors.text.primary,
    border: 'none',
    cursor: 'pointer',
    fontSize: theme.fontSize.md,
    fontWeight: '500',
    fontFamily: 'inherit',
    transition: 'all 0.2s',
    textAlign: 'left' as const,
  },
  dropdownItemActive: {
    backgroundColor: theme.colors.primary,
    color: theme.colors.text.white,
  },
  dropdownFlag: {
    fontSize: '18px',
  },
  dropdownName: {
    flex: 1,
  },
  // Compact mode styles (for Header)
  compactButton: {
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    backgroundColor: theme.colors.accent.emerald500,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '12px',
    borderBottom: `3px solid ${theme.colors.accent.emerald700}`,
    cursor: 'pointer',
    fontSize: theme.fontSize.sm,
    fontWeight: '700',
    fontFamily: 'inherit',
  },
  compactFlag: {
    fontSize: '18px',
  },
  compactCode: {
    fontSize: theme.fontSize.sm,
  },
};
